import * as state from './state.js';
let getters = {
    getPhone: state => {
        return state.login.phone;
    },
    getHeadImg: state => {
        return state.login.headimg;
    }
};
export default getters;


// WEBPACK FOOTER //
// ./src/vuex/modules/sevenAbilityIntroduce/getters.js